/** @file 举报反馈 语言配置 */
const zhCN = {
  feedBack: {
    feedType: '投诉类型',
    feedTypeOption1: '反馈',
    feedTypeOption2: '举报',
    stuck: '页面卡顿',
    blackScreen: '画面黑屏',
    slowAccess: '访问缓慢',
    poorExperience: '体验不好',
    playSuggestion: '玩法建议',
    otherFeedback: '其他反馈',
    porn: '色情低俗',
    uncivilized: '发言不雅',
    illegalEntry: ' 成员乱入',
    bloody: '恐怖血腥',
    scam: '欺诈信息',
    otherViolations: '其他',
    infringeRight: '侵犯权益',
    backType: '所属分类',
    feedContentLable: '反馈内容',
    feedContentContent: '请填写反馈内容',
    feedContentNum: '500字内',
    uploadTitle: '上传图片',
    uploadTitleMsg: '最多可上传1张，每张2M内',
    codeTitle: '验证码',
    codeplaceholder: '请输入验证码',
    phone: '联系方式',
    phoneMsg: '请留下您的手机号，方便回访',
    feedBackBtn: '提交',
    errorPhone: '手机号错误',
    errorCaptcha: '无效验证码',
    feedClassValue: '请选择具体分类',
    submitSuccess: '提交成功',
  },
};

const en = {
  feedBack: {
    feedType: 'Complaint type',
    feedTypeOption1: 'feedback',
    feedTypeOption2: 'Complaint',
    stuck: 'The page is stuck',
    blackScreen: 'Screen black screen',
    slowAccess: 'Slow access',
    poorExperience: 'Bad page',
    playSuggestion: 'Play suggestion',
    otherFeedback: 'Other',
    porn: 'vulgar porn',
    uncivilized: 'uncivilized',
    illegalEntry: 'illegal entry',
    bloody: 'horror bloody',
    scam: 'scam',
    infringeRight: 'infringe right',
    otherViolations: 'Other',
    backType: 'category',
    feedContentLable: 'Feedback content',
    feedContentContent: 'Please fill in the feedback',
    feedContentNum: 'Within 500 words',
    uploadTitle: 'Upload pictures',
    uploadTitleMsg: 'Upload screenshots up to 1 uploads, each within 2M',
    codeTitle: 'verification code',
    codeplaceholder: 'please enter verification code',
    phone: 'contact information',
    phoneMsg: 'Please enter phone number',
    feedBackBtn: 'Submit',
    errorPhone: 'Phone error',
    errorCaptcha: 'Invalid code',
    feedClassValue: 'please choose the type',
    submitSuccess: 'Success',
  },
};

export default {
  zh_CN: zhCN,
  en,
};
